import { lazy, Suspense, useState, cloneElement, isValidElement } from "react";
import type { ReactElement, ReactNode, MouseEvent } from "react";

const LazyBookingDialog = lazy(() => import("./BookingDialog"));

interface BookingCTAProps {
  trigger?: ReactNode;
}

/** Keeps the CTA button on the main bundle but defers loading the
 * booking form (react-day-picker, radix select/popover, date-fns, etc.)
 * until the visitor actually clicks it. */
const BookingCTA = ({ trigger }: BookingCTAProps) => {
  const [active, setActive] = useState(false);

  if (!active) {
    const idleTrigger =
      trigger && isValidElement(trigger)
        ? cloneElement(trigger as ReactElement<{ onClick?: (e: MouseEvent) => void }>, {
            onClick: (e: MouseEvent) => {
              (trigger as ReactElement<{ onClick?: (e: MouseEvent) => void }>).props.onClick?.(e);
              setActive(true);
            },
          })
        : trigger;
    return <>{idleTrigger}</>;
  }

  return (
    <Suspense fallback={trigger}>
      <LazyBookingDialog trigger={trigger} defaultOpen />
    </Suspense>
  );
};

export default BookingCTA;
